// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__dkBfA","title":"Content_title__196Mx","text":"Content_text__3xV4n"};